import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-pen",
  "use": "ico-pen-usage",
  "viewBox": "0 0 22.207 22.179",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22.207 22.179\" id=\"ico-pen\">\n  <path id=\"ico-pen_Path_220\" data-name=\"Path 220\" d=\"M3.788-143.028l5.844,5.573-.622.625-6.576.846,1.133-6.81Zm.155-.18,9.524-9.524,5.714,5.715-9.524,9.523Zm10.083-10.1,1.9-1.9a2.691,2.691,0,0,1,1.9-.789,2.691,2.691,0,0,1,1.9.789l1.906,1.9a2.692,2.692,0,0,1,.788,1.906,2.69,2.69,0,0,1-.788,1.9l-1.906,1.9Z\" transform=\"translate(-1.225 157)\" fill=\"none\" stroke=\"#d38529\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol